import { formatDistanceToNow } from "date-fns";
import { pl } from "date-fns/locale";
import { ChevronRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { StatusPill } from "@/components/StatusPill";

const previewText = (application) => {
  const answers = application?.answers || [];
  if (!answers.length) return "Brak odpowiedzi do podglądu.";
  return answers
    .slice(0, 2)
    .map((item) => `${item.question_label}: ${item.answer}`)
    .join(" • ");
};

export const HorizontalCardLane = ({ title, items, onOpen, emptyCopy, testId }) => {
  return (
    <section className="space-y-3" data-testid={testId}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-sm text-muted-foreground">{items.length} elementów</p>
        </div>
      </div>

      {items.length ? (
        <ScrollArea className="w-full rounded-2xl border border-border bg-card/40 p-3">
          <div className="flex min-w-full gap-4 pb-4">
            {items.map((application) => (
              <Card
                key={application._id}
                className="card-hover min-w-[320px] max-w-[420px] flex-1 border-border bg-card/95"
              >
                <CardHeader className="pb-3">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <CardTitle className="text-base">{application.applicant_display_name || "Nieznany kandydat"}</CardTitle>
                      <p className="mt-1 text-xs text-muted-foreground">ID Discord: <span className="font-mono">{application.applicant_discord_id}</span></p>
                    </div>
                    <StatusPill status={application.status} />
                  </div>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="min-h-[60px] text-sm leading-relaxed text-muted-foreground">
                    {previewText(application)}
                  </p>
                  <div className="flex items-center justify-between gap-3 border-t border-border pt-4">
                    <p className="text-xs text-muted-foreground">
                      Złożono {formatDistanceToNow(new Date(application.created_at), { addSuffix: true, locale: pl })}
                    </p>
                    <Button
                      onClick={() => onOpen(application)}
                      className="group"
                      data-testid="review-card-open-button"
                    >
                      Otwórz <ChevronRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
      ) : (
        <Card className="border-dashed border-border bg-card/70">
          <CardContent className="pt-6 text-sm text-muted-foreground">{emptyCopy}</CardContent>
        </Card>
      )}
    </section>
  );
};
